import { OrgChartProfile } from '../../domains/orgchart/OrgChartProfile';
import { ProcessProfile } from '../../domains/process/ProcessProfile';
import { GenogramProfile } from '../../domains/genogram/GenogramProfile';
import { NetworkProfile } from '../../domains/network/NetworkProfile';
import { GRCControlProfile } from '../../domains/grc-catalog/GRCControlProfile';
import { registerProcessOntologyMappings } from '../../domains/process/ontology/registerProcessOntologyMappings';
import { registerGrcCatalogOntologyMappings } from '../../domains/grc-catalog/ontology/registerGrcCatalogOntologyMappings';
import { registerNetworkOntologyMappings } from '../../domains/network/ontology/registerNetworkOntologyMappings';
import { registerOrgChartOntologyMappings } from '../../domains/orgchart/ontology/registerOrgChartOntologyMappings';
import { registerDomainProfile } from './profileRegistry';

export function registerDefaultProfiles(): void {
  registerDomainProfile(OrgChartProfile);
  registerDomainProfile(ProcessProfile);
  registerDomainProfile(GenogramProfile);
  registerDomainProfile(NetworkProfile);
  registerDomainProfile(GRCControlProfile);

  // Ontology property mappings — one source of truth for ontology→runtime
  // property projection. See docs/architecture/ontology-property-mapping.md.
  registerProcessOntologyMappings();
  registerOrgChartOntologyMappings();
  registerGrcCatalogOntologyMappings();
  registerNetworkOntologyMappings();
}
